export default {
    "Overview": "概览",
    "Energy": "能源",
    "KPI": "KPI",
    "Notification Breakdown": "通知明细",
    "Notification Summary": "通知明细",
    "Monthly Summary": "每月摘要",
    "Plots": "图表",
    "Time Series Plots": "时间序列序列图",
    "Equipment Plots": "设备图",
    "Facet Plots": "结合图",
    "Scatter Plots": "散点图",
    "Fault Detection": "故障检测",
    "Fault Detection (Machine Learning)": "故障检测（机器学习）",
    "Fault Summary": "故障摘要",
    "Diagnostics": "诊断",
    "Cooling Load": "冷负荷",
    "CHW Supply Temperature": "冷冻水供水温度",
    "CHW Return Temperature": "冷冻水回水温度",
    "Chiller Performance": "冷水机效能",
    "Cooling Performance": "冷却效能",
    "Working Hours": "运行时数",
    "Chiller Overview": "冷水机概览",
    "Config": "配置",
    "Equipments": "设备",
    "Facilities": "建筑物",
    "Anomaly Descriptions": "异常描述",
    "Points": "点位",
    "Parameter": "参数",
    "Settings": "设定",
    "Report": "报告",
    "Rules": "规则",
    "Export Data": "输出数据",
    "Custom Views": "自定义视图",
    "Dates": "日期",
    "Equipment Servicing Schedule": "设备维护时间表",
    "Menu items": "菜单项目",
    "Maintenance Record": "维护纪录",
    "Terms of Service": "服务条款",
    "Logged in as": "已登入为",
    "Account Settings": "帐户设定",
    "Logout": "登出",
    "Loading Points List": "正加载点位列表",
    "Save": "储存",
    "Cancel": "取消",
    "User Name": "用户名",
    "Email": "电邮地址",
    "Change password?": "更改密码？",
    "Issue": "问题",
    "Equipment": "设备",
    "Equipment Type": "设备类型",
    "Floor": "层数",
    "Start Date": "开始日期",
    "End Date": "结束日期",
    "Actions": "操作",
    "Energy Consumption VS Baseline": "能源消耗 VS 基准线",
    "Not including all equipment in the building": "不包括建筑物中的所有设备",
    "Hour": "小时",
    "Fault severity": "故障严重程度",
    "Fault breakdown": "故障明细",
    "Room Temperature": "室温",
    "AHU Run Time (hr)": "风柜运行时间（小时）",
    "Chiller Run Time (hr)": "冷水机运行时间（小时）",
    "User": "用户",
    "test": "测试",
    "Chillers": "冷水机",
    "Pumps": "泵",
    "VAVs": "变风量空调系统",
    "AHUs": "风柜组合",
    "Cooling Towers": "冷却塔",
    "Baseline": "基准线",
    "Power (Chiller only) ": "功率（仅适用于冷水机)",
    "Time": "时间",
    "Power Consumption": "功率消耗",
    "Energy Consumption Profile": "能源消耗概况",
    "Time (hourly)": "时间（小时）",
    "Energy Consumption Breakdown": "能源消耗明细",
    "Air conditioning - Air side": "空调 - 空气侧",
    "Power Heat Map": "功率热力图",
    "Chiller": "冷水机",
    "Chiller COP": "冷水机效能指数",
    "AHU": "风柜",
    "Annualized BPI": "年度BPI（建筑价格指数）",
    "Occupant Comfort Index": "停留者舒适指数",
    "Maintenance Fault Index": "故障维护率",
    "Energy Saving": "能源节约量",
    "Severity": "严重程度",
    "Topic": "主题",
    "Download": "下载",
    "Alerts": "警报",
    "Recommended Actions": "建议操作",
    "Acknowledged": "已确认",
    "Occured between": "发生介于",
    "and": "及",
    "Add Maintenance Record": "添加维护纪录",
    "View Chart": "查看图表",
    "View Chart in New Tab": "在新分页查看图表",
    "Add maintenance record": "添加维护纪录",
    "View chart": "查看图表",
    "View maintenanace records for this period": "查看此期间的维护纪录",
    "Equipment Health Score": "设备健康指数",
    "Export as PDF": "输出为PDF",
    "Create Maintenance Record": "创建维护纪录",
    "Jump to Equipment Trend Plots": "跳转至设备趋势图",
    "Supervised Detection": "监督性检测",
    "Algorithm Detection": "演算法检测",
    "Health": "健康度",
    "Sensor": "传感器",
    "Supervised Detection Scores (Higher indicates error)": "监督性检测指数（较高数值代表错误）",
    "Anomaly Detection Scores (Higher indicates error)": "异常检测指数（较高数值代表错误）",
    "Unack": "未确认",
    "Medium": "中",
    "High": "高",
    "30 days": "30天",
    "90 days": "90天",
    "1 year": "1年",
    "all": "全部",
    "Keyword filter": "关键字过滤",
    "Critical/High/Medium": "严重/高/中",
    "Low": "低",
    "Anomaly": "异常",
    "Relevant variables": "相关变量",
    "Fault Analysis": "故障分析",
    "Export all as PDF": "全部输出为PDF",
    "Rule evaluation": "规则评估",
    "Change": "变化",
    "Analysis": "分析",
    "Energy Consumption Comparison Summary": "能源消耗比较摘要",
    "Outdoor Temperature": "室外温度",
    "Fault Severity": "故障严重程度",
    "Chiller Running Hours": "冷水机运行时数",
    "Fault Breakdown": "故障明细",
    "Weather": "天气",
    "Baseline Weather": "基准天气",
    "Print": "列印",
    "Energy/Faults": "能源/故障",
    "Chiller Plant Performance": "冷水机组效能",
    "Current": "现在",
    "YTD this year": "本年度年初至今",
    "YTD last year": "前年度年初至今",
    "FDD Costs": "FDD诊断成本",
    "Unacknowledged": "未确认",
    "Total": "总计",
    "Plant COP (chiller only)": "机组效能指数（仅用于冷水机)",
    "Time ": "时间 ",
    "COP": "效能指数",
    "Chiller COP vs Cooling Load": "冷水机效能指数 vs 冷负荷",
    "Energy Consumption": "能源消耗",
    "Plant COP (chiller only) vs Outdoor Temperature": "机组效能指数（仅用于冷水机）vs 室外温度",
    "Header Main Supply Temperature vs Outdoor Temperature": "集管供水温度 vs 室外温度",
    "Outdoor Temp": "室外温度",
    "Header Main Supply Temperature": "集管供水温度",
    "Chilled Water Delta Temp": "冷却水温度变化",
    "Temperature Diff": "温度差异",
    "Chiller Plant": "冷水机组",
    "Runtime": "运行时间",
    "Fault": "故障",
    "No fault detected from": "没有发现故障",
    "to": "至",
    "View anomalies for": "查看此异常",
    "View notifications for": "查看此通知",
    "View equipment summary for": "查看此设备摘要",
    "FDD Faults":"FDD诊断结果",
    "Recommended actions": "建议操作",
    "Most Expensive Faults. Total Cost": "修复成本最高的故障。总成本",
    "Faults With Highest Duration Of Occurrence (hr)": "维持时间最长的故障（小时）",
    "Date From": "从此日期起",
    "Date To": "至此日期",
    "Fixed": "已修复",
    "Assigned to": "分配给",
    "Assigned by": "由...分配",
    "Assigned date": "分配日期",
    "Assigned to me": "分配给自己",
    "Assigned by me": "由自己分配",
    "View Points when Chiller is On":"查看冷水机开启时的点位",
    "Latest Cooling Load Forecast":"最新冷负荷预测",
    "Forecast":"预测",
    "Chiller Staging Profile":"冷水机分级概况",
    "Export charts as PDF":"输出图表为 PDF",
    "PMV":"预计平均热感觉指数（PMV）",
    "View this rule on other equipments in":"在其他设备上查看此规则",
    "View faults for":"为...查看故障",
    "Date Range":"日期范围",
    "Today":"今日",
    "Yesterday":"昨日",
    "Last 30 Days":"过去30日",
    "Fault Comparison":"比较故障",
    "Rule":"规则",
    "No matching equipments":"没有匹配的设备",
    "No Fault detected for this range and equipment":"未检测到该范围和设备的故障",
    "Equipment Name":"设备名称",
    "Search":"搜索",
    "Refresh":"更新",
    "Active (hr)":"运作时间（小时）",
    "Cost":"成本",
    "Active (as % of on time)":"运作时间（百分比）",
    "Last Detected":"最后检测时间",
    "Issues Diagnostics for":"为...诊断问题",
    "Other Readings":"其他读数",
    "Anomaly Machine Learning Models":"异常检测机器学习模型",
    "Anomaly machine learning models establish normal operation profile using historical data.":"异常检测机器学习模型使用了历史数据，以构筑正常操作配置概况。",
    "Machine Learning model is data driven and can handle non-linear boundaries and high dimensionality.":"异常检测机器学习模型是由数据主导，并能够处理非线性边界及更高维度。",
    "Show Mine Only":"仅显示自己的",
    "Bulk Upload Excel":"批量上传Excel",
    "Add Record":"添加纪录",
    "Notifications":"通知",
    "Show Unack Notifications Only":"仅显示未确认通知",
    "Add Plots":"添加图表",
    "Filter":"过滤",
    "Drag to Add Lines to Plot":"拖动以添加线至图表",
    "Password":"密码",
    "Login":"登入",
    "Set Server URL":"设置伺服器链结",
    "Variable X":"变量X",
    "Variable Y":"变量Y",
    "Facet Groups":"分面群组",
    "Variable Facet":"变量分面",
    "Chiller Optimisation Example":"冷水机优化示例",
    "Using PSO optimisation algorithm, expected COP under different operating parameters at particular cooling loads can be found as depicted by the red dots.  The historical consumption is shown as blue dots below.  By choosing optimal temperature setpoints and sequencing, energy saving can be achieved by picking the set of parameters achieving highest COP.":"运用粒子群优化算法后，红色点显示了特定冷却负载下不同参数的预期性能系数，蓝色点显示了能源消耗历史。只要设定了最佳的温度设定值和排序，再选出拥有最高效能指数的数据组合，就能够有效节能。",
    "95% Confidence Interval":"95%置信区间",
    "Actual observed value":"实际观测值",
    "Fitted value":"配适值",
    "Expected value":"期待值",
    "Upload File":"上传文件",
    "Remove existing rules":"移除现有规则",
    "Upload":"上传",
    "Upload Excel":"上传Excel",
    "Maintenance Records Creation":"创建维护记录",
    "Reference URL":"参考链接",
    "Fixed?":"已修复？",
    "Normal maintenance record":"正常维护纪录",
    "Comment":"评论",
    "Add":"添加",
    "View Reference Link":"查看参考链接",
    "View Reference Link in New Tab":"在新分页查看参考链接",
    "Optimization Saving":"优化所节约",
    "Digital Twins":"数字孪生",
    "Chiller Efficiency Surface":"冷水机效率面",
    "Optimization Saving Calculation":"优化节省计算",
    "Optimization is based on temperature reset of the chilled water supply temperature as well as optimal staging of chillers and pumps.":"优化是基于冷冻水供应温度的重置，以及冷水机和泵的最佳分级。",
    "Chillers' efficiency would also differ under different loading percentage, environmental conditions and external factors. This provides opportunity to improve the staging of chillers. Further optimization is possible due to unfulfilled temperature reset and differential pressure reset potential. Less cooling capacity buffer would be required if air-side sensors indicates that room temperature is optimal.":"在不同的负荷百分比，环境条件和其他外部因素的影响下，冷水机的效率也会有所变化。因此，冷水机的运作能够通过重置温度及压差达到进一步的优化。如果空气侧传感器显示室温为最佳，所需的冷却容量缓冲亦会因而减少。",
    "Total Cooling Load":"总冷负荷",
    "Duration":"持续时间",
    "Projected Energy Consumption":"预计能量消耗",
    "Saving":"节约",
    "Cost Savings":"成本节约",
    "Diagnostic Plots":"诊断图表",
    "Power consumption forecast based on setpoint such as evaporator supply temperature and external environment factors such as condenser water temperature and outdoor air temperature.":"功率预测是建基于不同设定值，例如蒸发器的供应温度、以及冷凝器水温和室外空气温度等外部环境因素。",
    "The charts reveal the relationship between the prediction and actual consumption.  A chart showing a strong correlation indicates a good model.": "这些图表展现了预测量与实际消耗量之间的关系。相关性越高代表模型越精准",
    "Chiller efficiency is greatly influenced by the loading of the chiller and external factor such as condenser water temperature.":"冷水机效率会受到机组负荷、以及冷却水温度等外部因素的大幅影响。",
    "The 3D scatter plots of the power consumption reveals a efficiency surface where chiller optimization can be performed.":"功率的立体散点图展现了一个可以执行冷水机优化的效率面。",
    "Chilled Water Supply Temp (actual)":"冷冻水供水温度（实际）",
    "Plant COP":"机组性能系数",
    "Plant Power":"机组功率",
    "Chilled Water Supply Temp (optimized)":"冷冻水供应温度（优化后）",
    "Original COP":"原始效能指数",
    "Optimized COP": "优化后效能指数",
    "Original Power": "原始功率",
    "Optimized Power": "优化后功率",
    "Menu Configuration":"菜单设置",
    "Air Side Equipment":"空气侧设备",
    "Overall Power Status":"整体功率状态",
    "Condensing Water Pump":"冷却水泵",
    "Power Analyzer":"功率分析仪",
    "Chilled Water Pump":"冷冻水泵",
    "Cooling Tower":"冷却塔",
    "CHW Header":"冷冻水集管",
    "Heatmaps":"热力图",
    "PAU Breakdown":"新风柜明细",
    "PAU CD_Tem & VFD_Feedback":"新风柜供应温度及变速驱动反馈",
    "AHU CD_Tem & RT_Tem & VFD_Feedback":"风柜供应温度及返回温度及",
    "AHU CD_Tem & RT_Tem & Valve_Control":"风柜供应温度及返回温度及阀门控制",
    "PAU CD_Tem & Valve_Control":"新风柜供应温度及阀门控制",
    "AHU RT_Tem vs. VFD_Feedback":"风柜返回温度 vs. 变速驱动反馈",
    "PAU CD_Tem vs. Valve Control":"新风柜供应温度 vs. 阀门控制",
    "AHU CD_Tem vs. Valve Control":"风柜供应温度 vs. 阀门控制",
    "AHU Breakdown":"风柜明细",
    "AHU CO2":"风柜二氧化碳",
    "PAU CO2":"新风柜二氧化碳",
    "Environmental Performance":"环保性能",
    "Running Status - CHWP & WCC":"运行状态 - 冷冻水泵 & 风冷式冷水机",
    "Equipment Power Consumption":"设备能量消耗",
    "Running Status - CHWP-A & ACC":"运行状态 - 冷冻水泵-A & 风冷式冷却机",
    "Running Status - WCC & CWP & CT":"运行状态 - 水冷式冷水机 & 冷却水泵 & 冷却塔",
    "Running Status - AHU & PAU":"运行状态 - 风柜 & 新风柜",
    "Running Status vs. Schedule":"运行状态 vs. 时间表",
    "CDW Delta T vs Mean CDWP Power":"冷却水温度差 vs 冷却水泵平均功率",
    "WCC Cond Entering & Leaving Temperature":"水冷式冷凝器的回水 & 供水温度",
    "WCC CHWR_Temp & CHWS_Temp":"水冷式冷水机的冷冻水返回 & 供应温度",
    "WCC Cooling Load Overview":"水冷式冷水机的冷负荷概览",
    "WCC COP":"水冷式冷水机效能指数",
    "COP vs Cooling Loads ":"效能指数 vs 冷负荷",
    "POA Power Factor":"能量分析仪能量因素",
    "POA Hz":"能量分析仪频率",
    "POA Voltage":"能量分析仪电压",
    "POA Power":"功率分析仪能量",
    "CHWP VSD_Speed_Feedback":"冷冻水泵 变频速度反馈",
    "CT Speed_Feedback":"冷却塔速度反馈",
    "CT Wetbulb Approach":"冷却塔湿球方法",
    "CT Breakdown":"冷却塔明细",
    "CT Speed Feedback & Running Status":"冷却塔速度反馈 & 运行状态",
    "CT Entering & Leaving Temperature":"冷却塔回水 & 出水温度",
    "AHU PAU Temperatures and Setpoints":"风柜及新风柜的温度及设定值",
    "CHW DP vs OAT":"冷冻水压差 vs 室外空气温度",
    "Second Floor Mean Air Temperature":"二楼平均空气温度",
    "First Floor Air Temperature":"一楼空气温度",
    "Reset":"重置",
    "Upload Point List":"上传点位列表",
    "Upload Point List CSV":"上传点位列表CSV文件",
    "Point List upload":"上传传感器列表",
    "Upload data for":"为...上传数据",
    "Upload CSV data for":"为...上传数据CSV文件",
    "Add Equipment":"添加设备",
    "Add Point":"添加点位",
    "Edit Equipment":"编辑设备",
    "Delete Equipment":"刪除设备",
    "Upload Data":"上传数据",
    "Edit Point":"编辑点位",
    "Delete Point":"删除点位",
    "Algorithmic Fault Detection":"算法故障检测",
    "Automated Debug": "自动Debug",
    "Custom View Configuration Issues":"自定义视图配置问题",
    "Chart Builder":"图表生成器",
    "Are you sure you want to delete this item?": "你确定要删除这个项目吗？",
    "Notes":"备注",
    "Sensor Name":"传感器名称",
    "Sensor Name Abbr":"传感器名称缩写",
    "Faulty":"故障",
    "Upstream ID":"上游点位ID",
    "Weight":"权重",
    "Are you sure you want to delete this sensor?":"你确定要删除这个传感器？",
    "Are you sure you want to delete this equipment?":"你确定要删除这个设备？",
    "Add Query":"添加查询",
    "Config ID":"配置ID",
    "Config Name":"配置名称",
    "Facility Name":"建筑物名称",
    "Equipment Tags":"设备标签",
    "Equipment ID":"设备ID",
    "Facility ID":"建筑物ID",
    "Description":"描述",
    "Sampling Frequency":"采样频率",
    "Meta":"属性",
    "ON":"开启",
    "OFF":"关闭",
    "Unit":"单位",
    "yes":"是",
    "Yes":"是",
    "no":"否",
    "No":"否",
    "Query":"查询",
    "data":"数据",
    "On Only":"仅运行的时候",
    "Date range offset":"日期范围偏移",
    "Add Time Aggregation":"添加聚合时间",
    "Add Aggregation":"添加聚合",
    "Add Series Calculation":"添加数组计算",
    "Add Dataframe Transformation":"添加数据帧转换",
    "Add Filter":"添加过滤",
    "Add Series Selection":"添加数组选择",
    "Add Series Insertion":"添加数组数据",
    "Range offset":"范围偏移",
    "Offset unit":"偏移单位",
    "Offset amount":"偏移数量",
    "Time Aggregation":"时间聚合",
    "Frequency":"频率",
    "Operation":"运算",
    "Divide by sampling freq":"除以采样频率",
    "Horizontal Aggregation":"横向聚合",
    "Name":"名称",
    "Insert Series":"载入一组数据",
    "Field":"列",
    "Value":"价值",
    "Series Calculation":"数组计算",
    "Remove Others":"删除其他",
    "Formula":"公式",
    "Dataframe Transformation":"数据帧转换",
    "Series Selection":"数组数据选择",
    "Add Series":"添加一组数据",
    "Please select a Sensor Name or an Equipment Name":"请选择传感器名称或设备名称",
    "layout":"排版",
    "Chart Type":"图表类型",
    "Trace Type":"轨迹类型",
    "Fill":"填满类型",
    "Fill color":"填充颜色",
    "Y Axis":"Y轴",
    "Stack Group":"叠加图组",
    "Render as Smooth Line":"算绘为平滑线",
    "Min":"最小",
    "Max":"最大",
    "Color":"颜色",
    "Custom Unit":"自定义单位",
    "Opacity":"不透明度",
    "Indicator Mode":"显示模式",
    "Gauge Min":"最小度量",
    "Gauge Max":"最大度量",
    "Bar color":"柱状颜色",
    "Border color":"边界颜色",
    "Background color":"背景颜色",
    "Bar Mode":"柱状图模式",
    "Show Scale":"显示比例",
    "Custom Color Gradient":"自定义颜色渐变",
    "Donut":"环形图",
    "Box Points":"箱形点位",
    "Horizontal":"水平方向",
    "Xbins Size":"X轴尺度大小",
    "Ybins Size":"Y轴尺度大小",
    "Add step":"添加步骤",
    "Gauge Steps":"测量步骤",
    "Title":"标题",
    "Chart layout":"图表排版",
    "Height":"高度",
    "Top Margin":"上边距",
    "Left Margin":"左边距",
    "Right Margin":"右边距",
    "Bottom Margin":"下边距",
    "Hover Tooltip Behaviour":"鼠标悬停工具提示效果",
    "Show Legend":"显示图例",
    "Chart Colors":"图表颜色",
    "Add Color":"添加颜色",
    "Axis settings":"轴设定",
    "X Axis Field":"X轴列",
    "Independent X Series per Query":"为每查询设定独立的数组X轴数据序列",
    "X Axis Label":"X轴标签",
    "X Axis Format":"X轴格式",
    "Y Axis Label":"Y轴标签",
    "Secondary Y Axis":"第二Y轴",
    "Secondary Y Axis Label":"第二Y轴标签",
    "Color Axis Field":"颜色轴列",
    "Color Axis Scale":"颜色轴比例",
    "Color Axis Label":"颜色轴标签",
    "3D Mode Y Axis Field":"3D模式Y轴场",
    "Close":"关闭",
    "Compare X":"比较X",
    "Closest to pointer":"最接近光标",
    "Primary":"主要",
    "Secondary":"第二",
    "hour":"小时",
    "day":"天",
    "week":"周",
    "month":"月",
    "year":"年",
    "Sensor ID":"传感器ID",
    "Type":"类型",
    "Connectors":"连接器",
    "Custom View Builder":"自定义视图生成器",
    "Edit Custom View":"编辑自定义视图",
    "Default Date Range":"预设日期范围",
    "Link Title":"链接标题",
    "Column width":"列宽",
    "Edit":"编辑",
    "Duplicate":"复制",
    "Delete":"删除",
    "Map":"地图",
    "Pitch":"间距",
    "Zoom":"缩放",
    "Center Latitude":"中心纬度",
    "Center Longitude":"中心经度",
    "Markers":"标记",
    "Image URL":"图像网址",
    "Link URL":"链接网址",
    "Latitude":"纬度",
    "Longitude":"经度",
    "Add Marker":"添加标记",
    "OK":"确认",
    "Width":"宽度",
    "Radius":"半径",
    "Blur":"模糊度",
    "Max opacity":"最大不透明度",
    "Player":"播放器",
    "Agg Frequency":"聚合频率",
    "Agg Operation":"聚合运算",
    "Cutoff Date":"截止日期",
    "Interpolation":"插值",
    "Min X":"X最小值",
    "Max X":"X最大值",
    "Min Power":"功率最小值",
    "Max Power":"功率最大值",
    "Power Sensor":"功率传感器",
    "X Sensor":"X 传感器",
    "X Title":"X 标题",
    "X Agg Operation":"X 聚合的运算",
    "Switch Sensor":"开关传感器",
    "Use Switch":"使用开关",
    "Custom Interpolation Function":"自定义插值函数",
    "Min Cooling Load":"最小冷负荷",
    "Max Cooling Load":"最大冷负荷",
    "COP Improvement":"改进效能指数(COP)",
    "Cooling Load Sensor":"冷负荷传感器",
    "Use Filter":"使用过滤",
    "Filter Sensor":"过滤传感器",
    "Min Filter":"过滤最小值",
    "Max Filter":"过滤最大值",
    "Correlation":"相关性",
    "Relevant Variables":"相关变量",
    "Rule Active when Equipment On":"设备开启时激活规则",
    "Rule Active when Equipment Off":"设备关闭时激活规则",
    "Rule Active Anytime":"规则随时有效",
    "Show Cost":"显示成本",
    "X Axis Title":"X轴标题",
    "Y Axis Title":"Y轴标题",
    "Expected Value Line Name":"预期值线名称",
    "Fitted Value Line Name":"配适值线名称",
    "Actual Observed Value Line Name":"实际观察值线名称",
    "Confidence Interval Name":"置信区间名称",
    "Cooling Load Forecast":"冷负荷预测",
    "Staging Profile":"分级资料",
    "Heatmap":"热图",
    "Fault Evaluation":"故障评估",
    "Chiller Sequencing FLA":"冷水机排序(满载电流)",
    "Chiller Sequencing Delta":"冷水机排序 Delta",
    "Cooling Load vs OAT":"冷负荷 vs 室外空气温度",
    "Return to Custom Views":"返回自定义视图",
    "Add chart":"添加图表",
    "Add Chart":"添加图表",
    "Save as custom view":"另存为自定义视图",
    "Add Custom Chart":"添加自定义图表",
    "Pie":"饼形图",
    "Bar":"柱状图",
    "Histogram":"直方图",
    "Stacked Area":"堆栈图",
    "Line":"线形图",
    "Scatter":"散点图",
    "3D Scatter":"3D散点图",
    "Scatter with Color Scale":"带有色标的散点图",
    "Optimization":"优化",
    "View All":"查看全部",
    "Changes Saved":"更改已保存",
    "Are you sure you want to delete this connector?":"您确定要删除此连接器吗？",
    "New Simple View":"新增基本视图",
    "New Advanced View":"新增高级视图",
    "Import JSON":"导入 JSON",
    "Import Preset":"导入预设",
    "Import Local Plots":"导入本机绘图",
    "Import custom view from JSON":"从 JSON 导入自定义视图",
    "Import":"导入",
    "Publish":"发布",
    "Un-Publish":"取消发布",
    "Export":"输出",
    "Facility":"建筑物",
    "Published":"发布",
    "Top-level Link":"置顶链接",
    "Link position":"链结位置",
    "Menu Folder":"导航菜单文件夹",
    "Are you sure you want to delete this view?":"您确定要删除此视图吗？",
    "View Deleted":"视图已删除",
    "Custom view saved":"自定义视图已保存",
    "Are you sure you want to upload all local plots to your user account?":"您确定要将所有本机绘图上传到您的用户帐户吗？",
    "Views Imported":"视图已导入",
    "A custom view with this ID already exists. Are you sure you want to override it ?":"已存在具有此ID的自定义视图。您确定要覆盖它吗",
    "End date":"结束日期",
    "Dynamic Control":"动态控制",
    "Software Switches":"软件开关",
    "Control Readings":"控制读数",
    "Sensor Readings":"传感器读数",
    "Point Name":"点位名称",
    "Status":"状态",
    "Error":"错误",
    "Equipment plots":"设备图表",
    "Equipment name":"设备名称",
    "Start date": "开始日期",
    "Floor name":"楼层名称",
    "Equipment Summary":"设备概要",
    "Display equipment plots":"展示设备图",
    "Display anomalies":"显示异常",
    "Data Export":"输出数据",
    "View Data":"查看数据",
    "Download CSV":"下载 CSV",
    "Time Agg Frequency":"时间聚合的频率",
    "Time Agg Operation":"时间聚合的运算",
    "Return data as":"返回数据为",
    "Series name":"一组数据名称",
    "Change Password":"更改密码",
    "User ID":"用户ID",
    "Update On":"更新时间",
    "Created On":"创建于",
    "Role":"角色",
    "Users":"用户",
    "Dashboard Setup":"仪表板设置",
    "Not logged in as administrator":"未以管理员身份登录",
    "Log Out":"登出",
    "Dashboard setup complete":"仪表盘设置完成",
    "Back to Home":"返回首页",
    "Current Logged In User":"当前登录用户",
    "Facility and Points":"建筑物和点位",
    "Current Facility":"当前的建筑物",
    "Equipment List and Points":"设备及点位列表",
    "used":"已使用",
    "licensed":"已发放许可",
    "Setting":"设定",
    "sample":"样本",
    "samples":"样本",
    "every hour":"每小时",
    "Currency and Energy Pricing":"货币和能源定价",
    "per kWh":"每千瓦时",
    "Points List":"点位列表",
    "Energy Price":"能源价格",
    "Equipment On":"设备开启",
    "Equipment Off":"设备关闭",
    "Anytime":"任何时间",
    "Active":"运作",
    "Inactive":"非运作",
    "Muted":"沉默",
    "Applicable Group(s)":"适用组别",
    "Rule Active when":"规则激活在...时候",
    "Active Status":"运作状态",
    "Reports":"报告",
    "Test Message":"测试讯息",
    "Severity Level(s)":"严重程度",
    "Distribution List":"分布列表",
    "Power Prediction":"功率预测",
    "Parameter Name":"参数名称",
    "Parameter Value":"参数值",
    "Parameter Value Str":"参数值字符串",
    "Parameter Description":"参数说明",
    "Graphical View":"图形视图",
    "Model":"模型",
    "Add Model":"添加模型",
    "Model Name":"模型名称",
    "Model Type":"模型类型",
    "Job":"工作",
    "Add Job":"添加任务",
    "New Job":"新任务",
    "No Result Yet":"没有结果",
    "Reset all result":"重置所有结果",
    "Reset all result will delete all result and rerun with latest setting.": "重置所有结果将会删除所有结果并使用最新设置重新运行",
    "Train Comp Power Model":"训练压缩机功率模型",
    "This will retrain the Comp Power Model":"将重新训练压缩机功率模型",
    "Ack Old Notifications":"已确认的旧通知",
    "Ack Old Notifications older than the following threshold or 30 days if no threshold is mentioned.":"如果未提及阈值，则确认早于以下阈值或 30 天前的旧通知",
    "End date threshold":"结束日期阈值",
    "Job ID":"任务ID",
    "Carnot Innovations Terms of Service":"Carnot Innovations 服务条款",
    "Critical":"危急",
    "Download with Maintenance": "下载(包括维护部分)",
    "Severity filter":"严重性过滤",
    "Notification ID":"通知 ID",
    "Occurred Times":"发生次数",
    "Focus Range":"关注范围",
    "Location":"地点",
    "Start Time":"开始时间",
    "End Time":"结束时间",
    "Comments":"注释",
    "Actions Taken":"所采取的行动",
    "Reported by": "报告人",
    "Report date":"报告日期",
    "Certified by":"通过...认证",
    "Certified date":"认证日期",
    "Endorsed by":"受...认可",
    "Endorsed date":"批准日期",
    "Menu List":"菜单列表",
    "New Folder Name":"新文件夹名称",
    "Available Views":"可用视图",
    "Edit Folder Name":"编辑文件夹名称",
    "Edit Custom View Display":"编辑自定义视图显示",
    "Custom View Name":"自定义视图名称",
    "Icon":"图标",
    "Folder cannot be nested!":"不能嵌套文件夹!",
    "Folder name must be unique.":"文件夹名称不能重复。",
    "Add Anomaly Description":"添加异常描述",
    "Relevant variable":"相关变量",
    "Equipment Regex":"设备正则表达式",
    "Time Delay":"时间延迟",
    "Open diagnostics view":"打开诊断视图",
    "timestamp":"时间戳",
    "Top 10 overall anomaly scores":"总体异常得分前10名",
    "File must be selected.":"必须选择文件。",
    "Exactly 1 file must be provided.":"至少提供1个文件",
    "Done":"完成",
    "Please select 1 file to upload.":"请选择1个文件上传。",
    "Please wait ... It will take up to a minute.": "请稍等... 大约等待一分钟",
    "Upload Completed.":"上传完成。",
    "Fail.  Please Retry.":"失败。请重试。",
    "Add Tag":"添加标签",
    "Connector":"连接器",
    "Add Points":"添加点位",
    "Point Selector":"选择点位",
    "Available points":"可用的点位",
    "Show filters":"显示过滤器",
    "Hide filters":"隐藏过滤器",
    "Selected points":"已选的点位",
    "Clear selection":"清空选项",
    "Add selected points":"添加已选点位",
    "Total energy consumption (kWh)":"总能源消耗（千瓦时）",
    "Energy Savings":"节能量",
    "Add Dates":"添加日期",
    "Add Equipment Servicing Schedule":"添加设备维修计划",
    "Applies to":"适用于",
    "Entire Site":"整个场地",
    "Floor Name":"楼层名称",
    "View":"视图",
    "Apply changes":"应用更改",
    "Save whiteboard":"储存白板",
    "Edit all notes":"编辑所有笔记",
    "Add Stickie to board":"将便条纸添加到白板上",
    "Add Photo / Graphics to board":"将照片/图形添加到白板上",
    "Add Board":"添加白板",
    "Board Name":"白板名称",
    "Double Click to select an image.":"双击以选择图像",
    "Edit this Stickie":"编辑此便条纸",
    "Delete this Stickie":"删除此便条纸",
    "Edit Image":"编辑图像",
    "Edit Label":"编辑标签",
    "Label":"标签",
    "Label Only":"仅编辑标签",
    "Font size":"字体大小",
    "Font color":"字体颜色",
    "Variable":"变量",
    "Microsoft authentication anomaly. Please renew login.":"Microsoft 身份验证异常。请更新登录。",
    "Change Backend URL":"更改后端 URL",
    "Target URL":"目标网址",
    "Setting URL.  Please wait.": "正在设置网址，请稍等。",
    "Set":"设定",
    "Model ID":"模型ID",
    "Target Equipment":"目标设备",
    "Model Selection":"选择模型",
    "Model Message":"模型信息",
    "Training Data Date Range":"训练数据日期范围",
    "Severity Levels":"严重程度",
    "Phone number":"电话号码",
    "Message":"信息",
    "Send":"发送",
    "Active - rule will be applied":"启用 - 规则会运行",
    "Inactive - rule will not run":"非启用 - 规则不会运行",
    "Muted - rules will be applied, but notifications (if any) will immediately be acknowledged":"沉默 - 应用规则，并且立即确认通知（如果有）",
    "Used parameters":"已使用的参数",
    "Recommended Action":"建议操作",
    "Run test":"运行测试",
    "Test the rule":"测试规则",
    "Validation succeeded!":"验证成功！",
    "Password not matched / Password cannot be empty":"密码不匹配/密码不能为空",
    "Confirm New Password":"确认新密码",
    "New Password":"新密码",
    "Administrator":"管理员",
    "Maintainer":"维护员",
    "Operator":"操作员",
    "Updated On":"更新于",
    "Authorized Facilities":"所授权的建筑物",
    "User Account":"用户帐号",
    "Monthly Summary Energy/Faults":"月度总结：总能源/故障",
    "Monthly Summary: Chiller Plant":"月度总结：冷水机组",
    "Chiller Staging":"冷水机分级",
    "Edit Maintenance Record":"编辑维护纪录",
    "Builder":"生成器",
    "Equipment Group":"设备组",
    "FDD Breakdown": "FDD的分析",
    "Cluster View": "群组视图",
    "Get link": "获取链接",
    "Chiller Plant Overview": "冷水机组概览",
    "General - CHW_Header Leaving and Entering Temp": "常规 - 冷冻水集管供水和回水温度",
    "General - CHW_Header DP vs OAT": "常规-冷冻水集管压差 vs 室外空气温度",
    "Advanced - Cooling Load and Power Over Time": "进阶 - 冷负荷和功率的变化",
    "Advanced - CHW_Header Depth Analysis": "进阶 - 冷冻水集管深度分析",
    "Cooling Load Prediction": "冷负荷预测",
    "Last 10 Days Cooling Load Prediction": "过去10日的冷负荷预测",
    "Hide Date": "隐藏日期",
    "Monthly": "每月",
    "Month Range": "月份范围",
    "On Only Switch": "仅计算开关运行的时候",
    "Equip Select": "设备选择",
    "Equipment Type filter": "设备类型过滤",
    "Equipment Floor filter": "设备楼层过滤",
    "Min Width": "最小宽度",
    "Borders": "边界",
    "Restricted Access": "限制访问权限",
    "Namespace": "名字空间",
    "Hide Controls": "隐藏控制",
    "Menu Config": "菜单项目",
    "Save As": "另存为",
    "Add Component": "添加组件",
    "Rich Text": "本文",
    "Notification Facet": "集管通知",
    "3D Viewer": "3D查看器",
    "3D Heatmap": "3D热图",
    "Custom Optimization": "自定义优化",
    "Custom COP Savings": "自定义节省效能指数",
    "Custom": "自定义",
    "HTML Code": "HTML代码",
    "Custom EC": "自定义EC",
    "Animation": "动画",
    "Enable Merge": "能够合并",
    "Animation timer (seconds)": "动画计时器（秒）",
    "Maintenance Summary": "维护摘要",
    "Issue Summary": "问题摘要",
    "Grahic": "图形",
    "FDD Report": "故障检测诊断报告",
    "Cost Breakdown": "成本分析",
    "Sensor Cailbration": "传感器校验",
    "Energy Breakdown": "能耗分析",
    "Solar": "来自太阳的",
    "Main light intensity": "主光强度",
    "Ambient light intensity": "环境光强度",
    "Show Clock": "显示时钟",
    "Parameters": "参数",
    "Autotuner": "自动调谐器",
    "Actual Observed Value": "实际观测值",
    "Fitted Value": "拟合值",
    "Expected Value": "期望值",
    "Insert at": "载入于",
    "Air-side": "空气侧",
    "Air-side Overview": "空气侧概览",
    "Air-side CO2 Overtime": "空气侧二氧化碳随时间的变化",
    "AHU Temp and VFD Over Time": "风柜温度和变速随时间的变化",
    "Download plot as a png": "下载图表为PNG",
    "Zoom in": "放大",
    "Zoom out": "缩小",
    "Autoscale": "自动缩放",
    "Reset axes": "重置轴",
    "Pan": "平移",
    "Toggle Spike Lines": "切换趋势图",
    "Show closest data on hover": "游标停留时显示最近的数据",
    "Compare data on hover": "游标停留时比较数据",
    "Produced with Plotly": "基于Plotly",
    "Rows per page": "每页行数",
    "Maintenance ID": "维护 ID",
    "View points when equipment is On": "查看设备开启时的点位",
    "Reassign user for all maintenance records": "为所有维护记录重新分配用户",
    "Mass Reassign": "批量重新分配",
    "Currently assigned to": "当前分配给",
    "Reassign to": "重新分配给",
    "Reassign": "重新分配",
    "View Diff": "查看差异",
    "Diff mode": "差异模型",
    "Select file": "选择文件",
    "Choose File": "选择文件",
    "Convert categorical to numeric": "将类别转换为数值",
    "Resampling": "重新采样",
    "Matching": "匹配",
    "Data Upload": "数据上传",
    "Toggle Connectors": "切换连接器",
    "Graphic": "图形",
    "Equipment Relationships": "设备关系",
    "Equipment1": "设备1",
    "Equipment2": "设备2",
    "Graph view": "图形视图",
    "List view": "列表视图",
    "Relationships type": "关系类型",
    "Equipment Relationships Upload": "设备关系上传",
    "Point Mapping": "点位映射",
    "Point Mapper": "点位映射器",
    "Mass Update": "批量更新",
    "Split Paths": "分隔路径",
    "Map Points": "映射点位",
    "Get Suggestions": "获取建议",
    "Suggestions": "建议",
    "Units": "单位",
    "Delete Table": "删除表格",
    "id": "ID",
    "path": "路径",
    "carnot_name": "Carnot名称",
    "point": "点位",
    "equip": "设备",
    "equip_type": "设备类型",
    "floor": "层数",
    "tower": "",
    "unit": "单位",
    "actions": "操作",
    "No data available": "没有显示数据",
    "Discovered Points": "已发现的点位",
    "upstream_id": "上游点位的ID",
    "upstream_sensor_name": "上游点位的传感器名称",
    "site": "场地",
    "sensor_name": "传感器名称",
    "sensor_desc": "传感器描述",
    "meta": "属性",
    "equip_meta": "设备属性",
    "Unmapped Only": "只显示未映射的点位",
    "Scripts": "脚本",
    "Script": "脚本",
    "Version": "版本",
    "Updated": "更新",
    "Optimization Controls": "优化控制",
    "Current Value": "当前值",
    "Write": "编写",
    "Priority": "优先顺序",
    "Graphics": "图形",
    "Dashboard": "仪表板",
    "Build time": "生成时间",
    "Coordinated Universal Time": "世界标准时间",
    "Rule Creation": "创建规则",
    "Auto-diagnose": "自动诊断",
    "This will disable all rules which lack the required variables. Are you sure you want to run auto-diagnostic?": "这将禁用所有缺少所需变量的规则。您确定要运行自动诊断吗？",
    "KPI Thresholds": "KPI临界值",
    "Custom view": "自定义视图",
    "New Link Name": "新链接名称",
    "Show Recent Notifications Only": "只显示最近的通知",
    "Apply": "应用",
    "3D Model link": "3D模型链接",
    "Close testing interface": "关闭测试界面",
    "Component Titles": "组件标题",
    "Last Updated": "最后更新",
    "Add components": "添加组件",
    "Toggle sensor picker": "切换传感器选择",
    "Toggle debug mode":"切换Debug模式",
    "Time aggregation": "合计时间",
    "Latest Only": "只显示最近的通知",
    "Custom date range": "自定义日期范围",
    "Presents": "目前",
    "Summary": "概要",
    "Bar - group": "分组条形图",
    "Bar - stack": "堆叠柱形图",
    "Bar summary": "柱形图概要",
    "Gauge": "仪表图",
    "Number": "数字图",
    "Layout": "排版",
    "Legend Position": "图例位置",
    "Colors": "颜色",
    "Limit X Axis Ticks": "限制X轴分段数",
    "Y Axis Format": "Y轴格式",
    "Y Axis Custom Range": "自定义Y轴范围",
    "Marker Size Field": "标记字段大小",
    "Color Axis Custom Range": "自定义色轴范围",
    "Annotations": "注释",
    "Text": "文字",
    "Returned series": "返回数组",
    "Add Series Insertion by Ref":"按参考添加数组",
    "Add Calendar Insertion": "添加一组日历",
    "Add Conversion to enum": "添加转换至枚举类型",
    "Number Size": "数字大小",
    "Number Format": "数字格式",
}